import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { createHybridStorage } from "./cookieStorage";

interface EvaluatorAuthState {
  token: string;
  firstName: string;
  email: string;
  parcoursEvaluateurId: string;
  setToken: (token: string) => void;
  setFirstName: (firstName: string) => void;
  setEmail: (email: string) => void;
  setParcoursEvaluateurId: (parcoursEvaluateurId: string) => void;
  clearToken: () => void;
  clear: () => void;
}

// Clé de stockage des données d'authentification
const STORAGE_KEY = "evaluator-auth";

// Stockage hybride : cookies en production, localStorage en développement
const hybridStorage = createHybridStorage<EvaluatorAuthState>(STORAGE_KEY, {
  days: 7,
  secure: true,
  sameSite: "Lax",
});

export const useEvaluatorAuthStore = create<EvaluatorAuthState>()(
  persist(
    (set) => ({
      token: "",
      firstName: "",
      email: "",
      parcoursEvaluateurId: "",
      setToken: (token) => set({ token }),
      setFirstName: (firstName) => set({ firstName }),
      setEmail: (email) => set({ email }),
      setParcoursEvaluateurId: (parcoursEvaluateurId) =>
        set({ parcoursEvaluateurId }),
      clearToken: () => set({ token: "", firstName: "", email: "" }),
      clear: () =>
        set({
          token: "",
          firstName: "",
          email: "",
          parcoursEvaluateurId: "",
        }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => hybridStorage),
    },
  ),
);
